const calculateAge = (birthDate) => {
    const today = new Date();
    const dob = new Date(birthDate);
    const diff = today.getTime() - dob.getTime();
    const years = Math.floor(diff / 31556736000);
    return years;
};

export default calculateAge;
